'use client';

import { ThemeEnum } from './Theme';
import ButtonLinkUI from './Button/ButtonLink';

const ButtonLink = ButtonLinkUI<ThemeEnum.Site>;

export default ButtonLink;
